// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__A3Q80","rotation":"SmallLoader_rotation__77RIk"};